<template>
    <div>
        <h1>User Aktivität</h1>
        <div class="horizontal-wrapper">
            <div></div>
            <md-switch class="md-primary" v-model="show_devs">Developers einbezogen</md-switch>
            <div></div>
            <div></div>
        </div>


        <div style="overflow-y: scroll; max-height: 80vh;">
            <div ref="chartbox"></div>
            <div style="flex: 0 0 20pt"></div>
            <div ref="user-activities"></div>
        </div>
    </div>
</template>
<script src="https://www.gstatic.com/charts/loader.js"></script>

<script>
import jexcelStyle from "jexcel/dist/jexcel.css"; // eslint-disable-line no-unused-vars
import jexcel from "jexcel"; // eslint-disable-line no-unused-vars
export default {
    name: 'user-activities-view',
    beforeRouteEnter (to, from, next) { 
        next(vm => { 
            vm.$socket.emit('get-user-activities', {token: vm.token, with_devs:vm.show_devs})
            next();
        }) 
    },
    computed:{
        token(){
            return this.$store.getters.token
        }
    },
    watch:{
        show_devs(){
            this.$socket.emit('get-user-activities-chart', {token: this.token, with_devs:this.show_devs})

            this.$socket.emit('get-user-activities', {token: this.token, with_devs:this.show_devs})
        }
    },
    sockets:{
        'set-user-activities-chart': function  (dataTable){
                const chartbox = this.$refs.chartbox
                const options = {
                     title: 'user aktivities',
                        legend: { position: "none" },
                        hAxis: { title: 'Date' },
                        vAxis: { title: 'Active' },
                        backgroundColor: 'white'
                }
                options.height = chartbox.getBoundingClientRect().height ;
                options.width = chartbox.getBoundingClientRect().width; 
                options.chartArea = {  left: 100, right: 30, width: options.width - 100 }
                
                const data = google.visualization.arrayToDataTable(dataTable.map((row, i) => (i)?[new Date(row[0]) , row[1], row[2]]: row) );

                const chart = new google.visualization.ColumnChart(chartbox);
                chart.draw(data, options); 
        },
        'set-user-activities':function(table){
            this.spreadsheet.setData(table)
        }
    },
    data(){
        return{
            show_devs: false,
            options: {
                 data:[[ '', '', '0.0.0.0', '',  ]],
                 columns:[
                     
                    { title:'username', width:120 },
                    { title:'lastlogin', width:120 },
                    { title:'ip', width:120 },

                    { title:'device-token', width:120 },
                    { title:'device', width:100 },
                    
                    { title:'login from device', width:100 },
                    
                    { title:'login all', width:100 },
                    { title:'devices', width:100 },

                ] 
            }
        }
    },
    mounted(){

        this.spreadsheet = jexcel(this.$refs['user-activities'], this.options);
     
        Object.assign(this, this.spreadsheet);
    }
}
</script>